<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label
      v-if="!!inputLabel"
      :for="inputName"
      slot="label">

      {{ inputLabel }}
    </label>

    <div
      :class="getInnerStyle"
      slot="input">

      <input-tag
        :addTagOnKeys="[32, 13, 188, 9]"
        :id="identification"
        :name="inputName"
        :tags.sync="tags"
        :placeholder="inputPlaceholder"
        :on-change="sendUpdate()"
        @update:tags="sendUpdate()" />

    </div>
  </input-base>
</template>

<script>
import InputTag from 'vue-input-tag'
import InputBase from '@/components/standard/input/InputBase'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'

export default {
  data () {
    return {
      tags: this.inputValue
    }
  },

  computed: {
    /**
     * Gives input's value
     * @returns {Array}
     */
    getInputValue () {
      return this.tags
    }
  },

  watch: {
    inputValue: function (newValue) {
      this.$set(this, 'tags', newValue)
    }
  },

  props: {
    hollow: {
      type: Boolean,
      required: false,
      default: false
    },
    inputValue: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  components: {
    'input-base': InputBase,
    'input-tag': InputTag
  },

  mixins: [
    stylers
  ]
}
</script>

<style scoped>
.standard-inner-input-style {
  padding-left: 15px;
  padding-right: 15px;
}
.vue-input-tag-wrapper {
  padding: 0;
  border: 0;
  background-color: transparent;
}
    
input {
  border: 0;
  width: 100%;
  outline: 0;
  padding: 1px 3px;
}

.small {
  padding-top: 0!important;
  padding-bottom: 0!important;
}

.hollow {
  border: 0!important;
}

.slimmer {
  padding: 0!important;
}

</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputTags.vue?75f98b28